import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
  safeValue,
  hasValue,
  isChecked,
  saveReceptionData,
  validateSums,
  validateExclusiveNA,
  getMaxValues,
  validateFlightSums,
} from "./util";

function ReceptionForm({ master, subproduct }) {
  const getCheckboxDefaultValue = (fieldName) => {
    const value = master?.preve_save?.[fieldName];
    return value === 1 || value === "1" || value === true;
  };

  const getRadioInitialValue = (fieldName) => {
    const value = master?.preve_save?.[fieldName];
    if (value === undefined || value === null) {
      return "";
    }
    if (value === 1 || value === 0 || value === 2) {
      return value.toString();
    }
    if (typeof value === "string") {
      return value;
    }
    return "";
  };

  const { register, handleSubmit, watch, setValue, getValues } = useForm({
    defaultValues: {
      // Documentos a entregar - Valores iniciales dinámicos
      master_awb: getRadioInitialValue("master_awb"),
      master_eawb: getCheckboxDefaultValue("master_awb_e"),
      house_manifest: getRadioInitialValue("house_manifest"),
      simplified_request: getRadioInitialValue("simplified_request"),
      cargo_transfer: getRadioInitialValue("cargo_transfer"),
      security_letter: getRadioInitialValue("security_letter"),
      acceptance_letter: getRadioInitialValue("acceptance_letter"),
      custom_badge: getRadioInitialValue("custom_badge"),

      // Naturaleza
      nat_cgo: master?.preve_save?.nat_cgo || false,
      nat_cgo_pieces: master?.preve_save?.nat_cgo_pieces || "",
      nat_cgo_weight: master?.preve_save?.nat_cgo_weight || "",
      nat_dgr: master?.preve_save?.nat_dgr || false,
      nat_dgr_pieces: master?.preve_save?.nat_dgr_pieces || "",
      nat_dgr_weight: master?.preve_save?.nat_dgr_weight || "",
      nat_per: master?.preve_save?.nat_per || false,
      nat_per_pieces: master?.preve_save?.nat_per_pieces || "",
      nat_per_weight: master?.preve_save?.nat_per_weight || "",
      nat_avi: master?.preve_save?.nat_avi || false,
      nat_avi_pieces: master?.preve_save?.nat_avi_pieces || "",
      nat_avi_weight: master?.preve_save?.nat_avi_weight || "",
      nat_val: master?.preve_save?.nat_val || false,
      nat_val_pieces: master?.preve_save?.nat_val_pieces || "",
      nat_val_weight: master?.preve_save?.nat_val_weight || "",
      nat_hum: master?.preve_save?.nat_hum || false,
      nat_hum_pieces: master?.preve_save?.nat_hum_pieces || "",
      nat_hum_weight: master?.preve_save?.nat_hum_weight || "",
      nat_dip: master?.preve_save?.nat_dip || false,
      nat_dip_pieces: master?.preve_save?.nat_dip_pieces || "",
      nat_dip_weight: master?.preve_save?.nat_dip_weight || "",
      nat_nwp: master?.preve_save?.nat_nwp || false,
      nat_nwp_pieces: master?.preve_save?.nat_nwp_pieces || "",
      nat_nwp_weight: master?.preve_save?.nat_nwp_weight || "",
      nat_mal: master?.preve_save?.nat_mal || false,
      nat_mal_pieces: master?.preve_save?.nat_mal_pieces || "",
      nat_mal_weight: master?.preve_save?.nat_mal_weight || "",
      nat_com: master?.preve_save?.nat_com || false,
      nat_com_pieces: master?.preve_save?.nat_com_pieces || "",
      nat_com_weight: master?.preve_save?.nat_com_weight || "",
      nat_vic: master?.preve_save?.nat_vic || false,
      nat_vic_pieces: master?.preve_save?.nat_vic_pieces || "",
      nat_vic_weight: master?.preve_save?.nat_vic_weight || "",
      nat_pil: master?.preve_save?.nat_pil || false,
      nat_pil_pieces: master?.preve_save?.nat_pil_pieces || "",
      nat_pil_weight: master?.preve_save?.nat_pil_weight || "",

      // Manejo
      han_ice: master?.preve_save?.han_ice || false,
      han_ice_pieces: master?.preve_save?.han_ice_pieces || "",
      han_ice_weight: master?.preve_save?.han_ice_weight || "",
      han_wet: master?.preve_save?.han_wet || false,
      han_wet_pieces: master?.preve_save?.han_wet_pieces || "",
      han_wet_weight: master?.preve_save?.han_wet_weight || "",
      han_big: master?.preve_save?.han_big || false,
      han_big_pieces: master?.preve_save?.han_big_pieces || "",
      han_big_weight: master?.preve_save?.han_big_weight || "",
      han_hea: master?.preve_save?.han_hea || false,
      han_hea_pieces: master?.preve_save?.han_hea_pieces || "",
      han_hea_weight: master?.preve_save?.han_hea_weight || "",
      han_hwc: master?.preve_save?.han_hwc || false,
      han_hwc_pieces: master?.preve_save?.han_hwc_pieces || "",
      han_hwc_weight: master?.preve_save?.han_hwc_weight || "",
      han_col: master?.preve_save?.han_col || false,
      han_col_pieces: master?.preve_save?.han_col_pieces || "",
      han_col_weight: master?.preve_save?.han_col_weight || "",
      han_fro: master?.preve_save?.han_fro || false,
      han_fro_pieces: master?.preve_save?.han_fro_pieces || "",
      han_fro_weight: master?.preve_save?.han_fro_weight || "",
      han_na: master?.preve_save?.han_na || false,
      han_na_pieces: master?.preve_save?.han_na_pieces || "",
      han_na_weight: master?.preve_save?.han_na_weight || "",

      // Contenedores activos
      contActivos_RKN: master?.preve_save?.contActivos_RKN || false,
      contActivos_RAP: master?.preve_save?.contActivos_RAP || false,
      prepContenedor_RKN: master?.preve_save?.prepContenedor_RKN || false,
      prepContenedor_RAP: master?.preve_save?.prepContenedor_RAP || false,
      contActivos_RKN_number: master?.preve_save?.contActivos_RKN_number || "",
      contActivos_RAP_number: master?.preve_save?.contActivos_RAP_number || "",
      prepContenedor_RKN_number:
        master?.preve_save?.prepContenedor_RKN_number || "",
      prepContenedor_RAP_number:
        master?.preve_save?.prepContenedor_RAP_number || "",

      // Entregas adicionales
      specialLoads: master?.preve_save?.special_cargo || false,
      interlineLoads: master?.preve_save?.interlineal_cargo || false,
      ata_sat_office: master?.preve_save?.ata_sat_office || "",
      intcar_transfer: master?.preve_save?.intcar_transfer || "",
      perishables_certified: master?.preve_save?.perishables_certified || "",
      dg: master?.preve_save?.dg || "",
      shipper_certified: master?.preve_save?.shipper_certified || "",
      hr_cert: master?.preve_save?.hr_cert || "",
      hr_permission_transfer: master?.preve_save?.hr_permission_transfer || "",
      hr_permission: master?.preve_save?.hr_permission || "",

      // DG
      has_dg_exempt: master?.preve_save?.has_dg_exempt || "",
      un_dg: master?.preve_save?.un_dg || "",

      // Temperatura
      required_temp: master?.preve_save?.required_temp || "N/A",
    },
  });

  console.log("===============reception=====================");
  console.log(master);
  console.log("====================================");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [leftValidation, setLeftValidation] = useState(null);
  const [rightValidation, setRightValidation] = useState(null);
  const [NAValidation, setNAValidation] = useState(true);
  const [flightSumErrors, setFlightSumErrors] = useState({
    col: null,
    fro: null,
  });
  const [maxValues, setMaxValues] = useState({ pieces: 0, weight: 0 });

  // Observar cambios para validaciones en tiempo real
  const watchAllFields = watch();

  // Inicializar valores máximos
  useEffect(() => {
    const max = getMaxValues(master);
    setMaxValues(max);
  }, [master]);

  // Validar sumas lado izquierdo
  useEffect(() => {
    const leftResult = validateSums(getValues(), master, "left");
    setLeftValidation(leftResult);
  }, [
    watchAllFields.nat_cgo,
    watchAllFields.nat_dgr,
    watchAllFields.nat_per,
    watchAllFields.nat_avi,
    watchAllFields.nat_val,
    watchAllFields.nat_hum,
    watchAllFields.nat_dip,
    watchAllFields.nat_nwp,
    watchAllFields.nat_mal,
    watchAllFields.nat_com,
    watchAllFields.nat_vic,
    watchAllFields.nat_pil,
    watchAllFields.nat_cgo_pieces,
    watchAllFields.nat_cgo_weight,
    watchAllFields.nat_dgr_pieces,
    watchAllFields.nat_dgr_weight,
    watchAllFields.nat_per_pieces,
    watchAllFields.nat_per_weight,
    watchAllFields.nat_avi_pieces,
    watchAllFields.nat_avi_weight,
    watchAllFields.nat_val_pieces,
    watchAllFields.nat_val_weight,
    watchAllFields.nat_hum_pieces,
    watchAllFields.nat_hum_weight,
    watchAllFields.nat_dip_pieces,
    watchAllFields.nat_dip_weight,
    watchAllFields.nat_nwp_pieces,
    watchAllFields.nat_nwp_weight,
    watchAllFields.nat_mal_pieces,
    watchAllFields.nat_mal_weight,
    watchAllFields.nat_com_pieces,
    watchAllFields.nat_com_weight,
    watchAllFields.nat_vic_pieces,
    watchAllFields.nat_vic_weight,
    watchAllFields.nat_pil_pieces,
    watchAllFields.nat_pil_weight,
  ]);

  // Validar sumas lado derecho y exclusividad N/A
  useEffect(() => {
    const rightResult = validateSums(getValues(), master, "right");
    setRightValidation(rightResult);

    const naValid = validateExclusiveNA(getValues());
    setNAValidation(naValid);
  }, [
    watchAllFields.han_ice,
    watchAllFields.han_wet,
    watchAllFields.han_big,
    watchAllFields.han_hea,
    watchAllFields.han_hwc,
    watchAllFields.han_col,
    watchAllFields.han_fro,
    watchAllFields.han_na,
    watchAllFields.han_ice_pieces,
    watchAllFields.han_ice_weight,
    watchAllFields.han_wet_pieces,
    watchAllFields.han_wet_weight,
    watchAllFields.han_big_pieces,
    watchAllFields.han_big_weight,
    watchAllFields.han_hea_pieces,
    watchAllFields.han_hea_weight,
    watchAllFields.han_hwc_pieces,
    watchAllFields.han_hwc_weight,
    watchAllFields.han_col_pieces,
    watchAllFields.han_col_weight,
    watchAllFields.han_fro_pieces,
    watchAllFields.han_fro_weight,
    watchAllFields.han_na_pieces,
    watchAllFields.han_na_weight,
  ]);

  // Validar sumas de vuelos
  useEffect(() => {
    if (watchAllFields.han_col) {
      const colValidation = validateFlightSums(getValues(), master, "col");
      if (colValidation && !colValidation.isValid) {
        setFlightSumErrors((prev) => ({ ...prev, col: colValidation.message }));
      } else {
        setFlightSumErrors((prev) => ({ ...prev, col: null }));
      }
    } else {
      setFlightSumErrors((prev) => ({ ...prev, col: null }));
    }

    if (watchAllFields.han_fro) {
      const froValidation = validateFlightSums(getValues(), master, "fro");
      if (froValidation && !froValidation.isValid) {
        setFlightSumErrors((prev) => ({ ...prev, fro: froValidation.message }));
      } else {
        setFlightSumErrors((prev) => ({ ...prev, fro: null }));
      }
    } else {
      setFlightSumErrors((prev) => ({ ...prev, fro: null }));
    }
  }, [
    watchAllFields.han_col,
    watchAllFields.han_col_pieces,
    watchAllFields.han_col_weight,
    watchAllFields.han_fro,
    watchAllFields.han_fro_pieces,
    watchAllFields.han_fro_weight,
    ...(master?.booking_flights || []).flatMap((_, index) => [
      watchAllFields[`flights_col_pieces_${index}`],
      watchAllFields[`flights_col_weight_${index}`],
      watchAllFields[`flights_fro_pieces_${index}`],
      watchAllFields[`flights_fro_weight_${index}`],
    ]),
  ]);

  const onSubmit = async (formData) => {
    // Validaciones antes de enviar
    const leftResult = validateSums(formData, master, "left");
    const rightResult = validateSums(formData, master, "right");
    const naValid = validateExclusiveNA(formData);

    if (!leftResult.isValid) {
      Swal.fire({
        title: "Error en sumas de Naturaleza",
        text: leftResult.errors.pieces || leftResult.errors.weight,
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    if (!rightResult.isValid) {
      Swal.fire({
        title: "Error en sumas de Manejo",
        text: rightResult.errors.pieces || rightResult.errors.weight,
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    if (!naValid) {
      Swal.fire({
        title: "Error en selección",
        text: "Si N/A está seleccionado, no puede haber otros tipos de manejo seleccionados",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    // Validar vuelos
    if (flightSumErrors.col) {
      Swal.fire({
        title: "Error en vuelos REFRI",
        text: flightSumErrors.col,
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    if (flightSumErrors.fro) {
      Swal.fire({
        title: "Error en vuelos CONGELADOR",
        text: flightSumErrors.fro,
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const userData = localStorage.getItem("user");
      const user = userData ? JSON.parse(userData) : null;
      await saveReceptionData(formData, master, subproduct, user);
    } catch (error) {
      console.error("Error in onSubmit:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Función para manejar cambios en N/A
  const handleNACheckbox = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      // Desmarcar todos los otros checkboxes de manejo
      const otherFields = [
        "han_ice",
        "han_wet",
        "han_big",
        "han_hea",
        "han_hwc",
        "han_col",
        "han_fro",
      ];
      otherFields.forEach((field) => {
        setValue(field, false);
        setValue(`${field}_pieces`, "");
        setValue(`${field}_weight`, "");
      });
    }
    setValue("han_na", isChecked);
  };

  // Función para manejar cambios en otros checkboxes (cuando N/A está seleccionado)
  const handleOtherCheckbox = (fieldName) => (e) => {
    if (watchAllFields.han_na && e.target.checked) {
      Swal.fire({
        title: "Advertencia",
        text: "N/A está seleccionado. Primero desmarque N/A para seleccionar otros tipos de manejo.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
      e.preventDefault();
      return false;
    }
    return true;
  };

  const handleTicket = () => {
    alert("Ticket");
  };

  if (!master) {
    return (
      <div className="container-fluid">
        <div className="alert alert-info text-center">
          Cargando datos del formulario...
        </div>
      </div>
    );
  }

  // Función para renderizar inputs con validación
  const renderValidatedInput = (
    field,
    type = "number",
    className = "",
    disabled = false
  ) => {
    const isInvalid =
      (field.includes("nat_") && leftValidation?.errors?.pieces) ||
      (field.includes("han_") && rightValidation?.errors?.pieces);

    return (
      <input
        type={type}
        {...register(field)}
        className={`form-control form-control-sm ${className} ${
          isInvalid ? "is-invalid" : ""
        }`}
        disabled={disabled}
        min="0"
        max={
          type === "number"
            ? field.includes("pieces")
              ? maxValues.pieces
              : maxValues.weight
            : undefined
        }
        step={
          type === "number" && field.includes("weight") ? "0.01" : undefined
        }
      />
    );
  };

  // Función auxiliar para renderizar radio buttons
  const renderRadio = (fieldName, value, label) => {
    const currentValue = watch(fieldName);
    return (
      <>
        {label}{" "}
        <input
          type="radio"
          name={fieldName}
          value={value}
          checked={currentValue === value}
          onChange={() => setValue(fieldName, value)}
        />
      </>
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-3">
              <p>
                <span className="fw-bold">Master:</span>{" "}
                {safeValue(master?.resp?.awb, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Origen:</span>{" "}
                {safeValue(master?.resp?.master_orig)}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Destino:</span>{" "}
                {safeValue(master?.resp?.master_dest, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Tipo de mercancía:</span>
                {safeValue(master?.resp?.master_merch, "N/A")}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <p>
                <span className="fw-bold">Piezas Master:</span>{" "}
                {safeValue(master?.resp?.master_pieces, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Peso Master:</span>{" "}
                {safeValue(master?.resp?.master_weight, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Volúmen Master:</span>{" "}
                {safeValue(master?.resp?.master_volume, "N/A")}
              </p>
            </div>
            {subproduct && (
              <div className="col-3">
                <p>
                  <span className="fw-bold">HBS:</span> {subproduct?.hbs}{" "}
                </p>
              </div>
            )}
          </div>

          {subproduct && (
            <div className="row">
              <div className="col-3">
                <p>
                  <span className="fw-bold">Piezas House:</span>{" "}
                  {safeValue(subproduct?.piezas, "N/A")}{" "}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Peso House:</span>{" "}
                  {safeValue(subproduct?.peso, "N/A")}{" "}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Volúmen House:</span>{" "}
                  {safeValue(subproduct?.peso, "N/A")}{" "}
                </p>
              </div>
            </div>
          )}

          <table className="table table-striped mt-3">
            <thead className="text-center">
              <tr>
                <th
                  style={{ backgroundColor: "#020C41", color: "white" }}
                  colSpan="6"
                >
                  Documentos a entregar
                </th>
              </tr>
              <tr className="text-center">
                <th></th>
                <th>No. Copias</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody className="text-center">
              {/* Guía Master */}
              <tr>
                <td className="text-start">Guía Master</td>
                <td>4</td>
                <td>{renderRadio("master_awb", "1", "Si")}</td>
                <td>{renderRadio("master_awb", "0", "No")}</td>
                <td>{renderRadio("master_awb", "2", "N/A")}</td>
                <td>
                  ¿e-AWB? (Guía Electrónica){" "}
                  <input
                    type="checkbox"
                    {...register("master_eawb")}
                    defaultChecked={getCheckboxDefaultValue("master_awb_e")}
                  />
                </td>
              </tr>

              {subproduct && (
                <tr>
                  <td className="text-start">House Manifest</td>
                  <td>4</td>
                  <td>{renderRadio("house_manifest", "1", "Si")}</td>
                  <td>{renderRadio("house_manifest", "0", "No")}</td>
                  <td>{renderRadio("house_manifest", "2", "N/A")}</td>
                  <td></td>
                </tr>
              )}

              {/* Pedimento Simplificado */}
              <tr>
                <td className="text-start">
                  Pedimento Simplificado con sello gama/DODA
                </td>
                <td>4</td>
                <td>{renderRadio("simplified_request", "1", "Si")}</td>
                <td>{renderRadio("simplified_request", "0", "No")}</td>
                <td>{renderRadio("simplified_request", "2", "N/A")}</td>
                <td></td>
              </tr>

              {/* Transferencia de carga */}
              <tr>
                <td className="text-start">Transferencia de carga</td>
                <td>2</td>
                <td>{renderRadio("cargo_transfer", "1", "Si")}</td>
                <td>{renderRadio("cargo_transfer", "0", "No")}</td>
                <td></td>
                <td></td>
              </tr>

              {/* Carta de seguridad */}
              <tr>
                <td className="text-start">Carta de seguridad</td>
                <td>2</td>
                <td>{renderRadio("security_letter", "1", "Si")}</td>
                <td>{renderRadio("security_letter", "0", "No")}</td>
                <td>{renderRadio("security_letter", "2", "N/A")}</td>
                <td></td>
              </tr>

              {/* Carta de aceptación */}
              <tr>
                <td className="text-start">Carta de aceptación</td>
                <td>2</td>
                <td>{renderRadio("acceptance_letter", "1", "Si")}</td>
                <td>{renderRadio("acceptance_letter", "0", "No")}</td>
                <td>{renderRadio("acceptance_letter", "2", "N/A")}</td>
                <td></td>
              </tr>

              {/* Copia gafete Aduanal */}
              <tr>
                <td className="text-start">Copia gafete Aduanal</td>
                <td>2</td>
                <td>{renderRadio("custom_badge", "1", "Si")}</td>
                <td>{renderRadio("custom_badge", "0", "No")}</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <table className="table table-striped mt-4">
            <colgroup>
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead className="text-center">
              <tr>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  NATURALEZA
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Piezas
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Peso
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  MANEJO
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  MANEJO
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Piezas
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Peso
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {/* Fila CGO (GENERAL) */}
              <tr className="text-start">
                <td className="text-end">CGO</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_cgo")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_cgo) === "1"
                    }
                  />{" "}
                  GENERAL
                </td>
                <td>
                  {watch("nat_cgo") && renderValidatedInput("nat_cgo_pieces")}
                </td>
                <td>
                  {watch("nat_cgo") && renderValidatedInput("nat_cgo_weight")}
                </td>
                <td className="text-end">ICE</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_ice")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_ice) === "1"
                    }
                    onClick={handleOtherCheckbox("han_ice")}
                  />{" "}
                  HIELO-SECO
                </td>
                <td>
                  {watch("han_ice") && renderValidatedInput("han_ice_pieces")}
                </td>
                <td>
                  {watch("han_ice") && renderValidatedInput("han_ice_weight")}
                </td>
              </tr>

              {/* Fila DGR (PELIGROSA) */}
              <tr className="text-start">
                <td className="text-end">DGR</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_dgr")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_dgr) === "1"
                    }
                  />{" "}
                  PELIGROSA
                </td>
                <td>
                  {watch("nat_dgr") && renderValidatedInput("nat_dgr_pieces")}
                </td>
                <td>
                  {watch("nat_dgr") && renderValidatedInput("nat_dgr_weight")}
                </td>
                <td className="text-end">WET</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_wet")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_wet) === "1"
                    }
                    onClick={handleOtherCheckbox("han_wet")}
                  />{" "}
                  HÚMEDA
                </td>
                <td>
                  {watch("han_wet") && renderValidatedInput("han_wet_pieces")}
                </td>
                <td>
                  {watch("han_wet") && renderValidatedInput("han_wet_weight")}
                </td>
              </tr>

              {/* Fila PER (PERECEDERO) */}
              <tr className="text-start">
                <td className="text-end">PER</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_per")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_per) === "1"
                    }
                  />{" "}
                  PERECEDERO
                </td>
                <td>
                  {watch("nat_per") && renderValidatedInput("nat_per_pieces")}
                </td>
                <td>
                  {watch("nat_per") && renderValidatedInput("nat_per_weight")}
                </td>
                <td className="text-end">BIG</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_big")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_big) === "1"
                    }
                    onClick={handleOtherCheckbox("han_big")}
                  />{" "}
                  GRANDE
                </td>
                <td>
                  {watch("han_big") && renderValidatedInput("han_big_pieces")}
                </td>
                <td>
                  {watch("han_big") && renderValidatedInput("han_big_weight")}
                </td>
              </tr>

              {/* Fila AVI (ANIMAL VIVO) */}
              <tr className="text-start">
                <td className="text-end">AVI</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_avi")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_avi) === "1"
                    }
                  />{" "}
                  ANIMAL VIVO
                </td>
                <td>
                  {watch("nat_avi") && renderValidatedInput("nat_avi_pieces")}
                </td>
                <td>
                  {watch("nat_avi") && renderValidatedInput("nat_avi_weight")}
                </td>
                <td className="text-end">HEA</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_hea")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_hea) === "1"
                    }
                    onClick={handleOtherCheckbox("han_hea")}
                  />{" "}
                  HEAVY
                </td>
                <td>
                  {watch("han_hea") && renderValidatedInput("han_hea_pieces")}
                </td>
                <td>
                  {watch("han_hea") && renderValidatedInput("han_hea_weight")}
                </td>
              </tr>

              {/* Fila VAL (ALTO VALOR) */}
              <tr className="text-start">
                <td className="text-end">VAL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_val")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_val) === "1"
                    }
                  />{" "}
                  ALTO VALOR
                </td>
                <td>
                  {watch("nat_val") && renderValidatedInput("nat_val_pieces")}
                </td>
                <td>
                  {watch("nat_val") && renderValidatedInput("nat_val_weight")}
                </td>
                <td className="text-end">HWC</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_hwc")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_hwc) === "1"
                    }
                    onClick={handleOtherCheckbox("han_hwc")}
                  />{" "}
                  FRAGIL
                </td>
                <td>
                  {watch("han_hwc") && renderValidatedInput("han_hwc_pieces")}
                </td>
                <td>
                  {watch("han_hwc") && renderValidatedInput("han_hwc_weight")}
                </td>
              </tr>

              {/* Fila HUM (RESTOS HUMANOS) */}
              <tr className="text-start">
                <td className="text-end">HUM</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_hum")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_hum) === "1"
                    }
                  />{" "}
                  RESTOS HUMANOS
                </td>
                <td>
                  {watch("nat_hum") && renderValidatedInput("nat_hum_pieces")}
                </td>
                <td>
                  {watch("nat_hum") && renderValidatedInput("nat_hum_weight")}
                </td>
                <td className="text-end">COL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_col")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_col) === "1"
                    }
                    onClick={handleOtherCheckbox("han_col")}
                  />{" "}
                  REFRI
                </td>
                <td>
                  {watch("han_col") && renderValidatedInput("han_col_pieces")}
                </td>
                <td>
                  {watch("han_col") && renderValidatedInput("han_col_weight")}
                </td>
              </tr>

              {/* Fila DIP (VALIJA DIPLOMATICA) */}
              <tr className="text-start">
                <td className="text-end">DIP</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_dip")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_dip) === "1"
                    }
                  />{" "}
                  VALIJA DIPLOMATICA
                </td>
                <td>
                  {watch("nat_dip") && renderValidatedInput("nat_dip_pieces")}
                </td>
                <td>
                  {watch("nat_dip") && renderValidatedInput("nat_dip_weight")}
                </td>
                <td className="text-end">FRO</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_fro")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_fro) === "1"
                    }
                    onClick={handleOtherCheckbox("han_fro")}
                  />{" "}
                  CONGELADOR
                </td>
                <td>
                  {watch("han_fro") && renderValidatedInput("han_fro_pieces")}
                </td>
                <td>
                  {watch("han_fro") && renderValidatedInput("han_fro_weight")}
                </td>
              </tr>

              {/* Fila NWP (PRENSA) */}
              <tr className="text-start">
                <td className="text-end">NWP</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_nwp")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_nwp) === "1"
                    }
                  />{" "}
                  PRENSA
                </td>
                <td>
                  {watch("nat_nwp") && renderValidatedInput("nat_nwp_pieces")}
                </td>
                <td>
                  {watch("nat_nwp") && renderValidatedInput("nat_nwp_weight")}
                </td>
                <td className="text-end">N/A</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_na")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_na) === "1"
                    }
                    onChange={handleNACheckbox}
                  />{" "}
                  NO APLICA
                </td>
                <td>
                  {watch("han_na") && renderValidatedInput("han_na_pieces")}
                </td>
                <td>
                  {watch("han_na") && renderValidatedInput("han_na_weight")}
                </td>
              </tr>

              {/* Fila MAL (MAIL) */}
              <tr className="text-start">
                <td className="text-end">MAL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_mal")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_mal) === "1"
                    }
                  />{" "}
                  MAIL
                </td>
                <td>
                  {watch("nat_mal") && renderValidatedInput("nat_mal_pieces")}
                </td>
                <td>
                  {watch("nat_mal") && renderValidatedInput("nat_mal_weight")}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              {/* Fila COM (COMAT AM) */}
              <tr className="text-start">
                <td className="text-end">COM</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_com")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_com) === "1"
                    }
                  />{" "}
                  COMAT AM
                </td>
                <td>
                  {watch("nat_com") && renderValidatedInput("nat_com_pieces")}
                </td>
                <td>
                  {watch("nat_com") && renderValidatedInput("nat_com_weight")}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              {/* Fila VIC (VALOR DECLARADO) */}
              <tr className="text-start">
                <td className="text-end">VIC</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_vic")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_vic) === "1"
                    }
                  />{" "}
                  VALOR DECLARADO
                </td>
                <td>
                  {watch("nat_vic") && renderValidatedInput("nat_vic_pieces")}
                </td>
                <td>
                  {watch("nat_vic") && renderValidatedInput("nat_vic_weight")}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              {/* Fila PIL (PHARMA) */}
              <tr className="text-start">
                <td className="text-end">PIL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_pil")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_pil) === "1"
                    }
                  />{" "}
                  PHARMA
                </td>
                <td>
                  {watch("nat_pil") && renderValidatedInput("nat_pil_pieces")}
                </td>
                <td>
                  {watch("nat_pil") && renderValidatedInput("nat_pil_weight")}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div className="row">
            <div className="col-5">
              <p>
                <span className="fw-bold">DESTINO ACAS:</span>&nbsp;{" "}
                {master?.acas_iatas ? "SI" : "NO"}
              </p>
            </div>
            <div className="col-6">
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <span className="fw-bold">*Temperatura requerida:</span>
                <select
                  className="form-select"
                  name="required_temp"
                  style={{ width: "auto" }}
                  {...register("required_temp")}
                  defaultValue={safeValue(
                    master?.preve_save?.required_temp,
                    "N/A"
                  )}
                >
                  {master?.temperatures && master?.temperatures.length > 0 ? (
                    master?.temperatures.map((temperature) => (
                      <option
                        key={temperature.id}
                        value={safeValue(temperature.name, "N/A")}
                      >
                        {safeValue(temperature.name, "N/A")}
                      </option>
                    ))
                  ) : (
                    <option value="N/A">N/A</option>
                  )}
                </select>
              </div>
            </div>
          </div>

          {safeValue(master?.merchandise_type?.name) === "Cont activos" && (
            <div className="row align-items-center mb-3">
              {/* Contenedores activos */}
              <div className="col-4 d-flex flex-column gap-3">
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Contenedores activos
                </p>

                {/* RKN */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("contActivos_RKN")}
                    defaultChecked={isChecked(
                      master?.preve_save?.contActivos_RKN
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("contActivos_RKN_number", "");
                      }
                    }}
                  />
                  <span>RKN</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("contActivos_RKN_number")}
                    disabled={!watch("contActivos_RKN")}
                    defaultValue={safeValue(
                      master?.preve_save?.contActivos_RKN_number,
                      ""
                    )}
                  />
                </div>

                {/* RAP */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("contActivos_RAP")}
                    defaultChecked={isChecked(
                      master?.preve_save?.contActivos_RAP
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("contActivos_RAP_number", "");
                      }
                    }}
                  />
                  <span>RAP</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("contActivos_RAP_number")}
                    disabled={!watch("contActivos_RAP")}
                    defaultValue={safeValue(
                      master?.preve_save?.contActivos_RAP_number,
                      ""
                    )}
                  />
                </div>
              </div>

              {/* Preparación de contenedor */}
              <div className="col-4 d-flex flex-column gap-3">
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Preparación de contenedor
                </p>

                {/* RKN */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("prepContenedor_RKN")}
                    defaultChecked={isChecked(
                      master?.preve_save?.prepContenedor_RKN
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("prepContenedor_RKN_number", "");
                      }
                    }}
                  />
                  <span>RKN</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("prepContenedor_RKN_number")}
                    disabled={!watch("prepContenedor_RKN")}
                    defaultValue={safeValue(
                      master?.preve_save?.prepContenedor_RKN_number,
                      ""
                    )}
                  />
                </div>

                {/* RAP */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("prepContenedor_RAP")}
                    defaultChecked={isChecked(
                      master?.preve_save?.prepContenedor_RAP
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("prepContenedor_RAP_number", "");
                      }
                    }}
                  />
                  <span>RAP</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("prepContenedor_RAP_number")}
                    disabled={!watch("prepContenedor_RAP")}
                    defaultValue={safeValue(
                      master?.preve_save?.prepContenedor_RAP_number,
                      ""
                    )}
                  />
                </div>
              </div>
            </div>
          )}

          {watch("han_col") &&
            master?.booking_flights &&
            master?.booking_flights.length > 0 && (
              <>
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Vuelos Reservados Refri
                </p>
                {flightSumErrors.col && (
                  <div className="alert alert-danger">
                    {flightSumErrors.col}
                  </div>
                )}
                <table className="table mt-3">
                  <thead className="text-center">
                    <tr>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Vuelo
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Año
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Hora
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Piezas
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Peso
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {master?.booking_flights.map((flight, index) => (
                      <tr key={index}>
                        <td>{safeValue(flight.flight, "N/A")}</td>
                        <td>{safeValue(flight.year, "N/A")}</td>
                        <td>{safeValue(flight.time, "N/A")}</td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_col_pieces_${index}`)}
                            defaultValue={safeValue(flight.col_pieces, "")}
                            className={`form-control form-control-sm ${
                              flightSumErrors.col ? "is-invalid" : ""
                            }`}
                            min="0"
                            max={
                              watchAllFields.han_col_pieces || maxValues.pieces
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_col_weight_${index}`)}
                            defaultValue={safeValue(flight.col_weight, "")}
                            className={`form-control form-control-sm ${
                              flightSumErrors.col ? "is-invalid" : ""
                            }`}
                            min="0"
                            step="0.01"
                            max={
                              watchAllFields.han_col_weight || maxValues.weight
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

          {watch("han_fro") &&
            master?.booking_flights &&
            master?.booking_flights.length > 0 && (
              <>
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Vuelos Reservados Conge
                </p>
                {flightSumErrors.fro && (
                  <div className="alert alert-danger">
                    {flightSumErrors.fro}
                  </div>
                )}
                <table className="table mt-3">
                  <thead className="text-center">
                    <tr>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Vuelo
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Año
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Hora
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Piezas
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Peso
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {master?.booking_flights.map((flight, index) => (
                      <tr key={index}>
                        <td>{safeValue(flight.flight, "N/A")}</td>
                        <td>{safeValue(flight.year, "N/A")}</td>
                        <td>{safeValue(flight.time, "N/A")}</td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_fro_pieces_${index}`)}
                            defaultValue={safeValue(flight.fro_pieces, "")}
                            className={`form-control form-control-sm ${
                              flightSumErrors.fro ? "is-invalid" : ""
                            }`}
                            min="0"
                            max={
                              watchAllFields.han_fro_pieces || maxValues.pieces
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_fro_weight_${index}`)}
                            defaultValue={safeValue(flight.fro_weight, "")}
                            className={`form-control form-control-sm ${
                              flightSumErrors.fro ? "is-invalid" : ""
                            }`}
                            min="0"
                            step="0.01"
                            max={
                              watchAllFields.han_fro_weight || maxValues.weight
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

          {watch("nat_dgr") && (
            <>
              <p className="amc-text fw-bold mt-4" style={{ color: "#020C41" }}>
                ¿Contiene DG exentas de verificación?
              </p>
              SÍ{" "}
              <input
                type="radio"
                style={{ marginRight: "14rem" }}
                {...register("has_dg_exempt")}
                value="si"
                defaultChecked={
                  safeValue(master?.preve_save?.has_dg_exempt) === "si"
                }
              />
              NO{" "}
              <input
                type="radio"
                {...register("has_dg_exempt")}
                value="no"
                defaultChecked={
                  safeValue(master?.preve_save?.has_dg_exempt) === "no"
                }
              />
              {watch("has_dg_exempt") === "no" && (
                <div style={{ marginTop: "1rem" }}>
                  <p
                    className="amc-text fw-bold mt-4"
                    style={{ color: "#020C41" }}
                  >
                    UN (MERCANCÍAS PELIGROSAS)
                  </p>
                  <input
                    type="text"
                    {...register("un_dg")}
                    defaultValue={safeValue(master?.preve_save?.un_dg, "")}
                    className="form-control mb-2"
                    style={{ width: "20%" }}
                  />
                  <p className="amc-notes" style={{ color: "#DC3545" }}>
                    Agregar cantidad total de UN en la guía
                  </p>
                </div>
              )}
            </>
          )}

          <div className="row">
            <div className="col">
              <p
                className="sub-title fw-bold mt-4"
                style={{ color: "#020C41" }}
              >
                Entregas adicionales
              </p>

              {/* CARGAS ESPECIALES */}
              <p>
                <input
                  type="checkbox"
                  {...register("specialLoads")}
                  defaultChecked={hasValue(master?.preve_save?.special_cargo)}
                />{" "}
                CARGAS ESPECIALES
              </p>
              {watch("specialLoads") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">Cuaderno ATA, Oficio SAT</td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            value="1"
                            checked={watch("ata_sat_office") === "1"}
                            onChange={() => setValue("ata_sat_office", "1")}
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            value="0"
                            checked={watch("ata_sat_office") === "0"}
                            onChange={() => setValue("ata_sat_office", "0")}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* CARGAS INTERLINEALES */}
              <p>
                <input
                  type="checkbox"
                  {...register("interlineLoads")}
                  defaultChecked={hasValue(
                    master?.preve_save?.interlineal_cargo
                  )}
                />{" "}
                CARGAS INTERLINEALES
              </p>
              {watch("interlineLoads") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">Transferencia</td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("intcar_transfer")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.intcar_transfer) ===
                              "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("intcar_transfer")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.intcar_transfer) ===
                              "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* PERECEDEROS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_per_disabled")}
                  checked={watch("nat_per")}
                  disabled
                />{" "}
                PERECEDEROS
              </p>
              {watch("nat_per") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">
                          Certificado fitosanitario o Certificado de negativa
                          del certificado
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("perishables_certified")}
                            value="1"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.perishables_certified
                              ) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("perishables_certified")}
                            value="0"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.perishables_certified
                              ) === "0"
                            }
                          />
                        </td>
                        <td>
                          N/A{" "}
                          <input
                            type="radio"
                            {...register("perishables_certified")}
                            value="2"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.perishables_certified
                              ) === "2"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* MERCANCÍAS PELIGROSAS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_dgr_disabled")}
                  checked={watch("nat_dgr")}
                  disabled
                />{" "}
                MERCANCÍAS PELIGROSAS
              </p>
              {watch("nat_dgr") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">DGD</td>
                        <td>2</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("dg")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.dg) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("dg")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.dg) === "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* ANIMALES VIVOS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_avi_disabled")}
                  checked={watch("nat_avi")}
                  disabled
                />{" "}
                ANIMALES VIVOS
              </p>
              {watch("nat_avi") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">
                          Certificado del embarcador (no IATA)
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("shipper_certified")}
                            value="1"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.shipper_certified
                              ) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("shipper_certified")}
                            value="0"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.shipper_certified
                              ) === "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* RESTOS HUMANOS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_hum_disabled")}
                  checked={watch("nat_hum")}
                  disabled
                />{" "}
                RESTOS HUMANOS
              </p>
              {watch("nat_hum") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <thead className="text-center">
                      <tr>
                        <th></th>
                        <th></th>
                        <th>* Incluye apostillado</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">
                          Certificado de Defunción*
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("hr_cert")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_cert) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("hr_cert")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_cert) === "0"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Permiso de Traslado*</td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("hr_permission_transfer")}
                            value="1"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.hr_permission_transfer
                              ) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("hr_permission_transfer")}
                            value="0"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.hr_permission_transfer
                              ) === "0"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">
                          Permiso de Embalsamamiento*
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("hr_permission")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_permission) ===
                              "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("hr_permission")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_permission) ===
                              "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col mt-4 d-flex justify-content-end gap-3">
              <button className="btnn" type="button" onClick={handleTicket}>
                Ticket
              </button>
              <button
                className="btnn"
                type="submit"
                disabled={
                  isSubmitting ||
                  (leftValidation && !leftValidation.isValid) ||
                  (rightValidation && !rightValidation.isValid) ||
                  !NAValidation ||
                  flightSumErrors.col ||
                  flightSumErrors.fro
                }
              >
                {isSubmitting ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default ReceptionForm;
